import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ComingSoon } from './components/common/ComingSoon';
import { ForgeLayout } from './components/layout/ForgeLayout';
import { LabelerManagementPage } from './pages/admin/LabelerManagementPage';
import { QueueManagementPage } from './pages/admin/QueueManagementPage';
import { AggregatedDashboard } from './pages/dashboard/AggregatedDashboard';
import { DailyReportDashboard } from './pages/dashboard/DailyReportDashboard';
import { DataCollectionDashboard } from './pages/dashboard/DataCollectionDashboard';
import { ForgeDashboardPage } from './pages/dashboard/ForgeDashboardPage';
import { LabelingAdminDashboard } from './pages/dashboard/LabelingAdminDashboard';
import { LiveStatusDashboard } from './pages/dashboard/LiveStatusDashboard';
import { MasterLabelUnresolvedDashboard } from './pages/dashboard/MasterLabelUnresolvedDashboard';
import { ForgeHomePage } from './pages/home/ForgeHomePage';
import { ForgeProfilePage } from './pages/profile/ForgeProfilePage';
import { DatabasePage } from './pages/system/DatabasePage';
import { FlowDiagramsPage } from './pages/system/FlowDiagramsPage';
import { GoalsPage } from './pages/system/GoalsPage';
import { TaskListPage } from './pages/system/TaskListPage';
import { TaskPlayerPage } from './pages/task-player/TaskPlayerPage';

const Placeholder: React.FC<{ title: string; desc: string }> = ({ title, desc }) => (
  <div className="page-content">
    <ComingSoon title={title} description={desc} />
  </div>
);

export const forgeRoutes: RouteObject = {
  path: '/forge',
  element: <ForgeLayout />,
  children: [
    { index: true, element: <ForgeHomePage /> },
    { path: 'tasks/player', element: <TaskPlayerPage /> },
    // Dashboards
    { path: 'dashboards/live-status', element: <LiveStatusDashboard /> },
    { path: 'dashboards/daily-report', element: <DailyReportDashboard /> },
    { path: 'dashboards/aggregated', element: <AggregatedDashboard /> },
    { path: 'dashboards/master-label-unresolved', element: <MasterLabelUnresolvedDashboard /> },
    { path: 'dashboards/data-collection', element: <DataCollectionDashboard /> },
    { path: 'dashboards/labeling', element: <LabelingAdminDashboard /> },
    // Admin
    { path: 'admin/queues', element: <QueueManagementPage /> },
    { path: 'admin/labelers', element: <LabelerManagementPage /> },
    {
      path: 'admin/chains',
      element: (
        <Placeholder
          title="Chain Config"
          desc="Configure chain-specific settings, detection parameters, and regeneration rules."
        />
      ),
    },
    {
      path: 'admin/qa-review',
      element: (
        <Placeholder
          title="QA Review"
          desc="Review flagged tasks, audit labeler decisions, and manage quality thresholds."
        />
      ),
    },
    // master-label route is registered at top level in App.tsx (accessible without internal access)
    // System
    { path: 'system/goals', element: <GoalsPage /> },
    { path: 'system/tasks', element: <TaskListPage /> },
    { path: 'system/flows', element: <FlowDiagramsPage /> },
    { path: 'system/database', element: <DatabasePage /> },
    // Profile
    { path: 'dashboard', element: <ForgeDashboardPage /> },
    { path: 'profile', element: <ForgeProfilePage /> },
  ],
};
